import { Suspense } from 'react'
import { Routes, Route, useParams } from 'react-router-dom'
import {
  CustomerList,
  CustomerDetails,
  Home,
  Profile,
  Auth,
  ResetPassword
} from 'pages'
import { PlaceHolder, NotFoundPage } from 'components'
import PublicRoutesOutlet from './PublicRoutesOutlet'
import ProtectedRoutesOutlet from './ProtectedRoutesOutlet'
import AppErrorBoundary from './AppErrorBoundary'
// Add public route
import PublicHashApp from './PublicHashApp'

const CustomerDetailsRoute = () => {
  const { id } = useParams()
  return <CustomerDetails key={id} />
}

const AppRoutes = () => {
  return (
    <AppErrorBoundary>
      <Suspense fallback={<PlaceHolder />}>
        <Routes>
          <Route path="/public/*" element={<PublicHashApp />} />
          <Route element={<PublicRoutesOutlet />}>
            <Route path="*" element={<Auth />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/forgot-password" element={<ResetPassword />} />
          </Route>
          <Route element={<ProtectedRoutesOutlet />}>
            <Route index element={<Home />} />
            <Route path="profile" element={<Profile />} />
            <Route path="customers">
              <Route path="list" element={<CustomerList />} />
              <Route path="details/:id" element={<CustomerDetailsRoute />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </AppErrorBoundary>
  )
}

export default AppRoutes
